import styled from 'styled-components/macro';

export const StatsEmptyStateWrapper = styled.div`
    border: ${({ theme }) => theme.border.base};
    border-radius: ${({ theme }) => theme.border.radiusBase};
    background-color: ${({ theme }) => theme.color.bgGrey};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 50px;
    height: 100%;
`;

export const Title = styled.div`
    padding-top: 8px;
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
    color: ${({ theme }) => theme.color.textBase};
`;

export const Info = styled.div`
    padding-top: 8px;
    text-align: center;
    width: 200px;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    color: ${({ theme }) => theme.color.textLight};
`;
